class HeaderDropDown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.openMenuMobile();
  }

  openMenuMobile() {
    this.dropdownButton = document.getElementById('MobileDropdownButton');
    this.navItems = document.getElementById('MobileDropdownMenu');
    this.toggle = this.querySelector('.open-close');

    this.dropdownButton.addEventListener('click', () => {
      if (this.navItems.hasAttribute('open')) {
        this.navItems.removeAttribute('open');
        this.dropdownButton.removeAttribute('open', '');
        document.body.style.overflow = 'auto';
        if (this.toggle) this.toggle.classList.remove('active');
      } else {
        this.navItems.setAttribute('open', '');
        this.dropdownButton.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        if (this.toggle) this.toggle.classList.add('active');
      }
    });
  }
}

customElements.define('header-dropdown', HeaderDropDown);
